import {useEffect} from "react";
import {connect} from "react-redux";
import {LOOK_OVERLAYS} from "../../core/constants";
import {setLookLockedTutorial} from "../../../../actions/lookFunctions";
import {getFeatureIsLocked} from "../../../../misc/helpers";
import PropTypes from "prop-types";
import {navItemInterface} from "../../../../interfaces/featureInterface";


const LookLockTutorialCaller = (props) => {

  const {fabricatorData, navItems, isPhoneNumberValidated, lookLockedTutorial, setLookLockedTutorial,
    lookOverlayOpened} = props;


  useEffect(() => {
    if (!navItems || !navItems.length || !fabricatorData.settings.leadCapture || lookLockedTutorial.finished
      || lookLockedTutorial.visible
      || isPhoneNumberValidated || (lookOverlayOpened && (lookOverlayOpened === LOOK_OVERLAYS.intro))) {
      return
    }
    const firstLockedIndex = navItems.findIndex(navItem => getFeatureIsLocked(navItem.part));
    const firstUnlockedIndex = navItems.findIndex(navItem => !getFeatureIsLocked(navItem.part));
    setLookLockedTutorial({
      visible: true,
      withGrid: true,
      firstLockedIndex,
      firstUnlockedIndex,
    })
  }, [navItems, fabricatorData, isPhoneNumberValidated, lookLockedTutorial, setLookLockedTutorial,
    lookOverlayOpened]);

  return null

};

LookLockTutorialCaller.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.shape(navItemInterface)).isRequired,
}

const mapStateToProps = (store) => {
  const {lookOverlayOpened, lookLockedTutorial} = store.lookState;
  const {isMobile, visualizersLoaded} = store.serverState;

  return {
    fabricatorData: store.fabricatorState,
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
    lookLockedTutorial,
    lookOverlayOpened,
  };
};

const mapDispatchToProps = {
  setLookLockedTutorial,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookLockTutorialCaller)

